/* eslint-disable react-hooks/exhaustive-deps */
import { Button, CircularProgress, Grid, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import validate from "validate.js";
import {
  resetStateAuth,
  setActiveSession,
  userLogin,
  verifyEmail,
} from "../../app/slices/authSlice";
import { showSnackbar } from "../../app/slices/commonSlice";
import logo from "../../assets/images/logo_black.png";
import "./Auth.css";

const Login = () => {
  const {
    data: dataLogin,
    status: statusLogin,
    error: errorLogin,
  } = useSelector(({ auth }) => auth.login);
  const {
    data: dataVerifyEmail,
    status: statusVerifyEmail,
    error: errorVerifyEmail,
  } = useSelector(({ auth }) => auth.verifyEmail);
  const { activeSession } = useSelector(({ auth }) => auth);

  const [errors, setErrors] = useState([]);
  const [action, setAction] = useState("email");
  const [formValues, setFormValues] = useState({});
  const [message, setMessage] = useState("");

  const dispatch = useDispatch();

  //use effects
  useEffect(() => {
    dispatch(resetStateAuth());
    setMessage("Provide your email address");
    return () => {
      dispatch(resetStateAuth());
    };
  }, []);

  useEffect(() => {
    if (dataLogin) {
      dispatch(setActiveSession(dataLogin));
    }
  }, [dataLogin]);

  useEffect(() => {
    if (dataVerifyEmail) {
      if (dataVerifyEmail === "EXTERNAL") {
        setMessage(
          "We have sent you a password to sign in in your email or phone number. Please provide it below to proceed",
        );
        setAction("password");
      } else if (dataVerifyEmail === "INTERNAL") {
        setMessage("Enter your password to proceed");
        setAction("password");
      }
    }
  }, [dataVerifyEmail]);

  useEffect(() => {
    if (errorVerifyEmail || errorLogin) {
      dispatch(
        showSnackbar({
          open: true,
          message: errorVerifyEmail?.message || errorLogin?.message,
          type: "error",
        }),
      );
    }
  }, [errorVerifyEmail, errorLogin]);

  //methods
  const handleChange = (e) => {
    const inputName = e.target.name;
    const inputValue = e.target.value;

    setFormValues({
      ...formValues,
      [inputName]: inputValue,
    });
  };

  const handleSubmit = () => {
    if (action === "email") {
      handleValidateEmail();
    } else if (action === "password") {
      handleLogin();
    }
  };

  const handleValidateEmail = () => {
    let _errors = validate(formValues, {
      email: {
        presence: { allowEmpty: false },
        email: true,
      },
    });

    if (_errors) {
      setErrors(_errors);
      return;
    } else {
      setErrors([]);
    }

    dispatch(
      verifyEmail({
        EMAIL: formValues?.email,
      }),
    );
  };

  const handleLogin = () => {
    dispatch(resetStateAuth());

    let _errors = validate(formValues, {
      password: {
        presence: { allowEmpty: false },
      },
    });

    if (_errors) {
      setErrors(_errors);
      return;
    } else {
      setErrors([]);
      dispatch(
        userLogin({
          EMAIL: formValues?.email,
          PASSWORD: formValues?.password,
        }),
      );
    }
  };

  //* builders
  const BuildForm = () => {
    return (
      <div className="app-form p-50">
        <h2 className="mb-20">Sign In</h2>
        <div id="message-container">{message}</div>
        <Grid container>
          {action === "email" && (
            <Grid className="padded-grid-item" item md={12} xs={12}>
              <TextField
                key={"input-email"}
                required
                fullWidth
                margin="dense"
                autoComplete="new-password"
                variant="outlined"
                error={errors["email"] ? true : false}
                helperText={errors["email"] ? errors.email[0] : null}
                name="email"
                id="email"
                label="Email"
                onChange={handleChange}
                value={formValues?.email}
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    handleSubmit();
                  }
                }}
              />
            </Grid>
          )}
          {action === "password" && (
            <Grid className="padded-grid-item" item md={12} xs={12}>
              <TextField
                key={"input-password"}
                required
                fullWidth
                margin="dense"
                type="password"
                autoComplete="new-password"
                variant="outlined"
                error={errors["password"] ? true : false}
                helperText={errors["password"] ? errors.password[0] : null}
                name="password"
                id="password"
                label="Password"
                onChange={handleChange}
                value={formValues?.password}
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    handleSubmit();
                  }
                }}
              />
            </Grid>
          )}
          <Grid item xs={12} md={12} className="padded-grid-item">
            <div className="flex-row mt-20 full-width justify-content-center ">
              <Button
                className="btn-login flex-row"
                variant="contained"
                onClick={handleSubmit}
                margin="dense"
                size="medium"
                disabled={
                  statusVerifyEmail === "loading" || statusLogin === "loading"
                }
              >
                {(statusVerifyEmail === "loading" ||
                  statusLogin === "loading") && (
                  <CircularProgress
                    size={20}
                    color="primary"
                    style={{ marginRight: "8px" }}
                  />
                )}
                {action === "email" ? "Sign In" : "Continue"}
              </Button>
            </div>
          </Grid>
        </Grid>
        <div className="auth-link mt-20">
          Don't have an account? Sign up <a href="/register-ext">here</a>
        </div>
      </div>
    );
  };

  return (
    <div className="flex-row auth-container flex-wrap">
      <div className="left flex-column align-items-center justify-content-center">
        <img id="logo" src={logo} alt="Bank of Tanzania" />
        <div className="mt-10">
          <h3 className="text-align-center">
            FinTech Regulatory Sandbox Portal
          </h3>
        </div>
      </div>
      <div className="right flex-row align-items-center justify-content-center">
        {BuildForm()}
      </div>
    </div>
  );
};

export default Login;
